import { MONAT_KURZ } from "../../hooks/useVertraege";
import type { VertragLeistung } from "../../hooks/useVertraege";

/** Monate einer Position als Text: „Mai (2×) · Sep". In einer Zeile ist
 *  „Mai · Mai · Sep" falsch — dort zählt man nicht, man liest. Im Kalender
 *  darunter steht der zweite Einsatz dagegen als zweiter Eintrag. */
export function monatsListe(monate: number[]): string {
  const je = new Map<number, number>();
  for (const m of monate) je.set(m, (je.get(m) || 0) + 1);
  return [...je.entries()].sort((a, b) => a[0] - b[0])
    .map(([m, n]) => MONAT_KURZ[m - 1] + (n > 1 ? ` (${n}×)` : "")).join(" · ");
}

export function titel(l: VertragLeistung): string {
  return l.titel_override || l.katalog_titel || "Leistung";
}

/** Vertrags-Detail (W7): Kopf + vier Tabs im hellen Design. Daten aus
 *  /api/pflege/vertraege/:id (Leistungen, Kalkulation, Ist, Zustimmung). */
export function Zeile({ l, r, strong }: { l: string; r: string; strong?: boolean }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: strong ? 15 : 14 }}>
      <span style={{ color: "var(--pf-ink-3)" }}>{l}</span>
      <span style={{ fontWeight: strong ? 800 : 600 }}>{r}</span>
    </div>
  );
}

